import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import groupBy from 'lodash/groupBy';
import forEach from 'lodash/forEach';
import { toCurrency } from '../../utils/utils';
import round from 'lodash/round';
import filter from 'lodash/filter';

class ProgressClaimReportContent extends React.Component {
	render() {
		const report = this.props.report || {};

		const claim = report.claim ? report.claim : { items: [] };
		const claimItems = claim.items;
		const claimItemsBySchedule = groupBy(claimItems, (i) => Number(`${i.scheduleOrder}.${i.scheduleOfRatesId}`));
		const tempClaimItems = filter(claim.items, i => i.claimType === 'Temporary');

		return (
		<div>
			<div className="lots-data">
				{
					map(claimItemsBySchedule, (items) => 
						!items[0].scheduleIsActive ? undefined : (
						<table className="report-table">
							<thead>	
								<tr className="schedule-header">
									<td colSpan={12}>{items[0].scheduleName}</td>
								</tr>
								<tr>
									<th>Item No</th>
									<th style={{ minWidth: '200px' }}>Description</th>
									<th>Unit</th>
									<th>Tendered Quantity</th>
									<th>Unit Rate($)</th>
									<th>Quantity Certified Previous Claim</th>
									<th>Certified Previous Claim</th>
									<th>Contractor Claim Quantity</th>
									<th>Contractor Claim</th>
									<th>Quantity To Date</th>
									<th>Certified to Date</th>
									<th>Certified this Period</th>
								</tr>
							</thead>
							<tbody>
								{
									(() => {
										let scheduleName = null;
										let prevCertTotal = 0;
										let claimTotal = 0;
										let certifiedToDateTotal = 0;
										let certifiedThisPeriodTotal = 0;

										const rows = [];

										scheduleName = items[0].scheduleName;
										
										forEach(items, (i) => {
											prevCertTotal += i.prevCertifiedAmount;
											claimTotal += round(i.claimQty * i.rate, 2);
											
											let certifiedToDate = 0;
											let certifiedThisPeriod = 0;
											if (!i.isTextOnlyLine) {
												certifiedToDate = i.prevCertifiedAmount + (i.certifiedAmount || i.calcCertifiedAmount);

												if (i.isNonLotBasedVariation) {
													certifiedThisPeriod = round(i.certifiedQty * i.rate, 2);
												} else if (i.certifiedAmount === null) {
													certifiedThisPeriod = i.calcCertifiedAmount;
												} else {
													certifiedThisPeriod = i.certifiedAmount;
												}
											}
											certifiedToDateTotal += certifiedToDate;
											certifiedThisPeriodTotal += certifiedThisPeriod;

											if (i.isTextOnlyLine) {
												rows.push(
													<tr>
														<td style={{ fontStyle: 'italic', backgrbackgroundColoround: '#FAFAFA' }}>{i.itemNo}</td>
														<td style={{ fontStyle: 'italic', backgroundColor: '#FAFAFA' }}>{i.description}</td>
														<td colSpan='10' style={{ fontStyle: 'italic', backgroundColor: '#FAFAFA' }}>{i.additionalInfo}</td>
													</tr>
												);
											} else {
												rows.push(
													<tr>
														<td>{i.itemNo}</td>
														<td>{i.description}</td>
														<td style={{ textAlign: 'right' }}>{i.unit}</td>
														<td style={{ textAlign: 'right' }}>{i.qty}</td>
														<td style={{ textAlign: 'right' }}>{toCurrency(i.rate)}</td>
														<td style={{ textAlign: 'right' }}>{round(i.prevCertifiedQty, 3)}</td>
														<td style={{ textAlign: 'right' }}>{toCurrency(i.prevCertifiedAmount)}</td>
														<td style={{ textAlign: 'right' }}>{round(i.claimQty, 3)}</td>
														<td style={{ textAlign: 'right' }}>{toCurrency(i.claimQty * i.rate, 3)}</td>
														<td style={{ textAlign: 'right' }}>{round(i.prevCertifiedQty + i.certifiedQty, 3)}</td>
														<td style={{ textAlign: 'right' }}>{toCurrency(certifiedToDate)}</td>
														<td style={{ textAlign: 'right' }}>{toCurrency(certifiedThisPeriod)}</td>
													</tr>
												);
											}
										});

										rows.push(
											<tr className="schedule-total">
												<td colSpan={6}>{scheduleName} Total</td>
												<td style={{ textAlign: 'right' }}>{toCurrency(prevCertTotal)}</td>
												<td></td>
												<td style={{ textAlign: 'right' }}>{toCurrency(claimTotal)}</td>
												<td></td>
												<td style={{ textAlign: 'right' }}>{toCurrency(certifiedToDateTotal)}</td>
												<td style={{ textAlign: 'right' }}>{toCurrency(certifiedThisPeriodTotal)}</td>
											</tr>
										);
											
										return rows;
									})()
								}
							</tbody>
						</table>
					))
				}

				{tempClaimItems.length > 0 && 
					<table className="report-table">
						<thead>	
							<tr className="schedule-header">
								<td colSpan={5}>Temporary Claim Items</td>
							</tr>
							<tr>
								<th>Item No</th>
								<th style={{ minWidth: '200px' }}>Description</th>
								<th>Contractor Claim</th>
								<th style={{ minWidth: '300px' }}>Comments</th>
							</tr>
						</thead>
						<tbody>
							{
								(() => {
									const rows = [];
									forEach(tempClaimItems, (i) => {
										rows.push(
											<tr>
												<td>{i.itemNo}</td>
												<td>{i.description}</td>
												<td style={{ textAlign: 'right' }}>{toCurrency(i.claimAmount, 3)}</td>
												<td style={{ textAlign: 'right' }}>{i.comments}</td>
											</tr>
										);
									});

									rows.push(
										<tr className="schedule-total">
											<td colSpan={3}>Temporary Claim Items Total</td>
											<td></td>
										</tr>
									);
										
									return rows;
								})()
							}
						</tbody>
					</table>
				}
			</div>
		</div>
    );
  }
}

ProgressClaimReportContent.propTypes = {
	report: PropTypes.object.isRequired
};

export default ProgressClaimReportContent;
